import { useState, useEffect, Fragment } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export const useCourseModule = () => {
  const { moduleSlug } = useParams();
  const { api } = useAuth();
  const [module, setModule] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/course-modules/by-slug/${moduleSlug}`)
      .then(res => setModule(res.data))
      .catch(() => setNotFound(true));
  }, [api, moduleSlug]);

  return {
    module,
    notFound,
    slug: moduleSlug,
    moduleName: module?.name || '',
    apiBase: `/modules/${moduleSlug}`,
    adminBase: `/admin/module-builder/${moduleSlug}`,
    learnerBase: `/courses/${moduleSlug}`
  };
};

// Remounts children when the module slug in the URL changes so no state leaks between modules
export const ModuleScoped = ({ children }) => {
  const { moduleSlug } = useParams();
  return <Fragment key={moduleSlug}>{children}</Fragment>;
};
